import React, { useEffect, useState } from 'react'
import { any, func } from 'prop-types'

import { Form, FormErrorHandler } from '../../Form'
import { Social } from '../Social'
import { SignUpInputs } from './SignUpInputs'

export const SignUpForm = ({ onSignUp, errors, handleRedirect, openChild }) => {
  const [clearCaptcha, setClearCaptcha] = useState(false)

  useEffect(() => {
    if (errors?.email || errors?.password) {
      setClearCaptcha(true)
    }
  }, [errors])

  return (
    <>
      <Form
        initialValues={{
          email: '',
          password: '',
          passwordConfirmation: '',
          captcha: null,
          fundraiser: false,
        }}
        onSubmit={onSignUp}
      >
        <FormErrorHandler errors={errors} />
        <SignUpInputs
          signUpErrors={errors}
          clearCaptcha={clearCaptcha}
          setClearCaptcha={setClearCaptcha}
        />
      </Form>
      <div style={{ textAlign: 'center' }}>or</div>
      <Social token={handleRedirect} openChild={openChild} />
    </>
  )
}

SignUpForm.propTypes = {
  onSignUp: func,
  errors: any,
  handleRedirect: func,
  openChild: func,
}
